import { InputStylesStructure } from '@pijma/hero-types'

export const InputBaseStyles: InputStylesStructure['styleProvider'] = {
  root: (props) => ({}),
  childrenWrapper: (props) => ({}),
  input: (props) => ({}),
  textarea: (props) => ({}),
  label: (props) => ({}),
  error: (props) => ({}),
  description: (props) => ({}),
  descriptionLink: (props) => ({}),
  descriptionWrapper: (props) => ({}),
  startIcon: () => ({}),
  clearIcon: () => ({}),
  endIcon: () => ({}),
}
